<template>
  <div>
    <div v-show="listing" class="app-content content ">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
                name="Withdrawal Request"
                bc1="App"
                bc2="Withdrawal Request"
                bc3="List"
            ></Breadcrumb>
          </div>
        </div>
        <div class="content-body">
          <div class="card">
            <CommonTable
                :url="url"
                :tableHeaderValues="tableHeaderValues"
                :actions="actions"
                :deleteActions="deleteActions"
                :mutedData="mutedData"
                :storageKey="storageKey"
                :externalTotalRecord="externalTotalRecord"
                :filteredData="filteredData"
                :exportData="exportData"
                :hidePdfExportButton="true"
                @getFullResponse="getFullResponse"
                :show-per-page="true"
            />
          </div>
        </div>
      </div>
      <WithDrawalRequestDetailModal :show="withDrawalRequestDetail" :data="withDrawalRequestDetailData"
                                    @hide="withDrawalRequestDetail = false"

      />
      <WithDrawalMethodDetialModal :show="showModel" :data="withdrawalData"
                                   @hide="showModel = false"

      />
      <DetailTextModal :show="showDescriptionModal" :text="description"
                       @hide="showDescriptionModal = false" />
    </div>
    <RefundGatewayDetails :rowData="rowData" v-if="!listing " @backFromDetailPage="listing = true" />
  </div>


</template>

<script>
import WithDrawalRequestDetailModal from "@/pages/dashboard/withdrawal-requests/WithDrawalRequestDetailModal";
import WithDrawalMethodDetialModal from "@/pages/dashboard/withdrawal-requests/WithDrawalMethodDetialModal";
import RefundGatewayDetails from "@/pages/dashboard/refund-request/RefundGatewayDetails";
import DetailTextModal from "@/components/common/modals/DetailTextModal";
export default {
  props: ['propFilters'],
  components: {DetailTextModal, WithDrawalRequestDetailModal,WithDrawalMethodDetialModal,RefundGatewayDetails },
  mounted() {
    localStorage.setItem("url", "v1/get-withdrawal-request");
    this.checkDataInStore('v1/get-withdrawal-request')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }

    if(typeof(this.propFilters) != 'undefined'){

      let filterData = {}

      if(this.propFilters.currentPage){
        filterData.page = this.propFilters.currentPage
      }

      this.filteredData = filterData
    }
  },
  data() {
    return {
      listing:true,
      description:'',
      showDescriptionModal:false,
      rowData:[],
      currentPage:1,
      filteredData:{},
      exportData:{
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'withdrawals',
          }


          this.downloadReport(requestData)
        }
      },
      withDrawalRequestDetail: false,
      withDrawalRequestDetailData: [],
      url: "v1/get-withdrawal-request",
      storageKey: "withdrawalRequest",
      isDefault: false,
      showModel: false,
      withdrawalData: "",
      withdrawalDataValue: "",
      tableHeaderValues: [
        {
          title: "UUID",
          valueKey: "uuid",
          html: true,
          alter: (value,row) => {
            var html = "";
            if (value) {
              if(row.added_by_user){
                html = `
                <div class="row">
                    <div class="col-12">
                        <div class="badge text-primary mt-1"><span >${value}</span></div>
                        <div class="badge badge-light-danger mt-1">${row.added_by_user.email}</div>
                        <div class="badge badge-light-primary mt-1">Direct Withdrawal</div>
                    </div>
                </div>
                `

              }else{
                html = `<div class="badge text-primary mt-1"><span >${value}</span></div>`
              }

              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Gateway Reference Id",
          valueKey: "gw_reference_id",
          html: true,
          alter: function(value) {
            var html = "-";
            if (value) {
              html = `<span class="badge text-success">${value}</span>`;
              html = `
                <div class="row">
                    <div class="col-12 text-center">
                       ${html}
                        <div class="badge badge-dark mt-1" style="cursor: pointer;">Show Gateway Details</div>
                    </div>
                </div>
                `

            }

            return html

          },
          cta: (row) => {
            this.rowData = row
            this.listing = false
          }
        },
        {
          title: "Reference Id",
          valueKey: "reference_id",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-dark">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Description",
          valueKey: "description",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-danger" style="cursor: pointer" title="click to view full description">${value.substring(0,12)+'...'}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            this.description = row.description
            this.showDescriptionModal = true
          }
        },
        {
          title: "First Name",
          valueKey: "user_account.user",
          alter: function(value) {
            if (value) {
              return value.first_name;
            } else {
              return '-';
            }
          }
        },
        {
          title: "Last Name",
          valueKey: "user_account.user",
          alter: function(value) {
            if (value) {
              return value.last_name;
            } else {
              return '-';
            }
          }
        },
        {
          title: 'Email',
          valueKey: "user_account.user.email",
          html: true,
          alter: function (value) {
            var html = '-'
            if(value)
            html = html = ` <a href="javascript:void()" class="badge badge-glow badge-dark">${value}</a>`

            return html


          }
        },
        {
          title: 'Account Title',
          valueKey: 'user_account.account_title',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-light-info badge-info">${value}</a>`

            return html


          }
        },
        {
          title: "Account Number",
          valueKey: "user_account",
          html: true,
          alter: function(value) {
            if (value) {
              return `<span class="text-primary">${value.account_number}</span>`;
            } else {
              return value;
            }
          }
        },
        {
          title: "Payment Method",
          valueKey: "with_drawal_method.payment_method.name",
          html: true,
          alter: function(value) {
            var html = '-'
            if(value)
              html = ` <a href="javascript:void()" class="badge badge-glow badge-warning">${value}</a>`

            return  html
          }
        },
        {
          title: "Amount",
          valueKey: "amount",
          html: true,
          alter: (value,row) => {
            if (!value) {
              return "-";
            } else {
              return `<span class="text-primary">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</span>&nbsp<div class="badge badge-light-success">${row.user_account.currency.code}</div>`;
            }
          }
        },
        {
          title: "Created Date / Time",
          valueKey: "created_at",
        alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            }
            else if(value == 2 ) {
              html = `<span class="badge badge-danger badge-sm">Canceled</span>`;
            }
            else if(value == 3 ) {
              html = `<span class="badge badge-danger badge-sm">Rejected</span>`;
            }
            else if(value == 4 ) {
              html = `<span class="badge badge-success badge-sm">Accepted</span>`;
            }else{
              html = `<span class="badge badge-warning badge-sm">Pending</span>`;
            }


            return html;
          }
        }
      ],
      actions: [
        {
          title: "Method Details",
          class: "badge btn-primary  ml-1",
          modalId: "v-b-modal.modal-primary",
          cta: (row, index) => {
            this.showWithdrawalDetails(row, index);
          }
        },
        {
          title: 'Request Details',
          class: 'btn-primary badge',
          cta: (row, index) => {
            this.showModel = false
            this.withDrawalRequestDetailData = row.with_drawal_request_details
            this.withDrawalRequestDetail = true
          },

        },
        {
          title: "Change Status",
          class: "badge btn-success  ml-1",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "ChangeWithdrawalStatus"
            };
            this.$store.dispatch("set", data);
            let propFilters = {}
            propFilters.currentPage = this.currentPage
            this.$router.push({ name: "withdrawal-status",params: {propFilters: propFilters} });
          }
        }
      ],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    getFullResponse(response) {
      if (typeof (response.fullResponse) != 'undefined') {
        let data = response.fullResponse
        this.currentPage = data.paginationData.currentPage
        // delete this.filteredData.page
      }
    },
    showWithdrawalDetails(row) {
      this.showModel = true;
      if (row.with_drawal_method !== null) {
        //this.withdrawalData = row.with_drawal_method.details;
        // this.withdrawalData = Object.keys(row.with_drawal_method.details);
        // this.withdrawalDataValue = Object.values(
        //   row.with_drawal_method.details
        // );
        this.withdrawalData = row.with_drawal_method.details
      }
    },
    deleteRecord(row) {
      this.makeRequest("post", "v1/delete-role", {
        status: row.status == true ? 1 : 0,
        id: row.id
      });
    }
  }
};
</script>
